module.exports = __webpack_public_path__ + "img/logo.c8378802.png";